<header class="topbar">
  <!-- Search (desktop) -->
  <div class="topbar-search hide-mobile">
    <span class="material-symbols-outlined">search</span>
    <input class="input-field" type="text" placeholder="Buscar tipos de evento..." />
  </div>

  <!-- Mobile: branding -->
  <div class="topbar-brand hide-desktop">
    <div class="logo-icon-sm">
      <span class="material-symbols-outlined">architecture</span>
    </div>
    <span class="brand-name">Fluid Architect</span>
  </div>

  <div class="topbar-actions">
    <!-- Theme toggle -->
    <button class="icon-btn" (click)="theme.toggle()" [title]="theme.isDark ? 'Modo claro' : 'Modo oscuro'">
      <span class="material-symbols-outlined">{{ theme.isDark ? 'light_mode' : 'dark_mode' }}</span>
    </button>

    <!-- Notifications -->
    <button class="icon-btn icon-btn--notify">
      <span class="material-symbols-outlined">notifications</span>
      <span class="notify-dot"></span>
    </button>

    <!-- Avatar -->
    <div class="topbar-avatar">
      <span class="material-symbols-outlined" style="font-size:1.25rem; color: var(--on-surface-variant);">account_circle</span>
    </div>
  </div>
</header>
